import React from "react";

const inclusions = [
  { label: "Turnitin AI + similarity reports" },
];

const OrderInclusionsStrip = () => (
  <section
    aria-label="Included"
    className="w-full max-w-4xl rounded-[16px] border border-[#dbe4f2] bg-white/90 px-4 py-3 shadow-[0_10px_26px_rgba(15,23,42,0.04)]"
  >
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      <p className="shrink-0 text-xs font-semibold uppercase tracking-[0.18em] text-[#1d4ed8]">
        Included
      </p>

      <div className="flex flex-wrap gap-x-4 gap-y-2">
        {inclusions.map(({ label }) => (
          <div key={label} className="flex items-center gap-2 text-sm font-semibold text-[#111827]">
            <span
              aria-hidden="true"
              className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#eff6ff] text-xs font-bold text-[#2563eb]"
            >
              ✓
            </span>
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default OrderInclusionsStrip;
